import React from 'react';
import { PauseCircle } from 'lucide-react';

export const GATE_PROPOSED_SHORT = 'Proposed. Not in service.';
export const GATE_OPEN = false;

export function GateLegalStatusNote({ testid = 'gate-legal-status-note' }) {
  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/[0.06] p-4 mb-6 text-sm text-amber-100/80 leading-relaxed" data-testid={testid}>
      <span className="font-semibold text-amber-200">Status: proposed, not in service.</span> Kojiru placed the Binding Action Gate in proposed status on October 12, 2026. Kojiru does not accept new consent receipts, gate checks, allowlists, postures, or payments, and no one can accept these terms by using the gate. The text below stays published only as the record of what applied to receipts signed before the pause, and to revoking them.
    </div>
  );
}

export function GateProposedNotice({ testid = 'gate-proposed-notice', compact = false }) {
  return (
    <div className={`rounded-2xl border border-amber-500/40 bg-amber-500/[0.06] ${compact ? 'p-4' : 'p-6'} flex gap-3`} data-testid={testid}>
      <PauseCircle className="w-5 h-5 shrink-0 text-amber-300 mt-0.5" />
      <div>
        <div className="text-sm font-semibold text-amber-200">The Binding Action Gate is a proposed design and is not in service.</div>
        <p className="text-xs text-amber-100/70 mt-1 leading-relaxed">
          Kojiru is not accepting consent receipts, gate checks, allowlists, postures, or payments for the gate. Nothing on this page can authorize, execute, or charge anything. Receipts signed before the pause remain on the public record, and their signers can still revoke unused ones.
        </p>
      </div>
    </div>
  );
}
